import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';

const GlobalTrapAlertBanner = () => {
  const navigate = useNavigate();
  const [activeAlerts, setActiveAlerts] = useState([]);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const response = await fetch(`${config.TRAP_API_BASE_URL}/api/alerts`);
        if (response.ok) {
          const data = await response.json();
          setActiveAlerts(data);
        }
      } catch (error) {
        console.error('Error fetching trap alerts:', error);
      }
    };

    fetchAlerts();
    const interval = setInterval(fetchAlerts, 2000);
    return () => clearInterval(interval);
  }, []);

  if (activeAlerts.length === 0) return null;

  // We can just show the first active alert, or a summary
  const firstAlert = activeAlerts[0];
  const isRodent = firstAlert.unit_type === 'versa_rodent';
  const targetRoute = isRodent ? '/rodent-stations' : '/bedbug-traps';
  
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#f43f5e',
        color: 'white',
        padding: '12px 20px',
        textAlign: 'center',
        fontWeight: 'bold',
        cursor: 'pointer',
        zIndex: 9999,
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px'
      }}
      onClick={() => navigate(targetRoute)}
    >
      <span style={{ fontSize: '20px' }}>🚨</span>
      <span>
        ACTIVE {isRodent ? 'RODENT' : 'BEDBUG'} ALERT: {firstAlert.event_type || 'Detection'} - {firstAlert.device_id} at {firstAlert.location_section} - {new Date(firstAlert.triggered_at).toLocaleString()}. Click here to view.
      </span>
      <span style={{ fontSize: '20px' }}>🚨</span>
    </div>
  );
};

export default GlobalTrapAlertBanner;
